import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { WidgetApp, widgetThemes } from "./WidgetApp";
import { WIDGET_BACKEND_URL } from "./config";
function mergeOptions(options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22;
    const env = (_a = options.env) !== null && _a !== void 0 ? _a : "local";
    const baseUrl = (_b = options.apiBaseUrl) !== null && _b !== void 0 ? _b : WIDGET_BACKEND_URL;
    const themeName = options.themeName === "dark" ? "dark" : "light";
    const baseTheme = widgetThemes[themeName];
    if (!options.projectId || !options.publicKey) {
        throw new Error("ChatbotWidget.mount requires projectId and publicKey.");
    }
    return {
        target: (_c = options.target) !== null && _c !== void 0 ? _c : "chatbot-widget",
        floating: (_d = options.floating) !== null && _d !== void 0 ? _d : true,
        env,
        apiBaseUrl: baseUrl,
        brandName: (_e = options.brandName) !== null && _e !== void 0 ? _e : "Personal Assistant",
        themeName,
        // Script-selected theme is the base. Runtime customization is applied later from backend config.
        theme: {
            ...baseTheme,
            corner: (_g = (_f = options.theme) === null || _f === void 0 ? void 0 : _f.corner) !== null && _g !== void 0 ? _g : baseTheme.corner,
            position: (_j = (_h = options.theme) === null || _h === void 0 ? void 0 : _h.position) !== null && _j !== void 0 ? _j : baseTheme.position,
            background: (_l = (_k = options.theme) === null || _k === void 0 ? void 0 : _k.background) !== null && _l !== void 0 ? _l : baseTheme.background,
            homepageGradientBaseColor: (_o = (_m = options.theme) === null || _m === void 0 ? void 0 : _m.homepageGradientBaseColor) !== null && _o !== void 0 ? _o : baseTheme.homepageGradientBaseColor,
            cardBackgroundColor: (_q = (_p = options.theme) === null || _p === void 0 ? void 0 : _p.cardBackgroundColor) !== null && _q !== void 0 ? _q : baseTheme.cardBackgroundColor,
            activeCardBackgroundColor: (_s = (_r = options.theme) === null || _r === void 0 ? void 0 : _r.activeCardBackgroundColor) !== null && _s !== void 0 ? _s : baseTheme.activeCardBackgroundColor,
            userMessageBackgroundColor: (_u = (_t = options.theme) === null || _t === void 0 ? void 0 : _t.userMessageBackgroundColor) !== null && _u !== void 0 ? _u : baseTheme.userMessageBackgroundColor,
            userMessageTextColor: (_w = (_v = options.theme) === null || _v === void 0 ? void 0 : _v.userMessageTextColor) !== null && _w !== void 0 ? _w : baseTheme.userMessageTextColor,
            chatHeaderBackgroundColor: (_y = (_x = options.theme) === null || _x === void 0 ? void 0 : _x.chatHeaderBackgroundColor) !== null && _y !== void 0 ? _y : baseTheme.chatHeaderBackgroundColor,
            activeChatBackgroundColor: (_0 = (_z = options.theme) === null || _z === void 0 ? void 0 : _z.activeChatBackgroundColor) !== null && _0 !== void 0 ? _0 : baseTheme.activeChatBackgroundColor,
            assistantTextColor: (_2 = (_1 = options.theme) === null || _1 === void 0 ? void 0 : _1.assistantTextColor) !== null && _2 !== void 0 ? _2 : baseTheme.assistantTextColor,
            closedFlowsBackgroundColor: (_4 = (_3 = options.theme) === null || _3 === void 0 ? void 0 : _3.closedFlowsBackgroundColor) !== null && _4 !== void 0 ? _4 : baseTheme.closedFlowsBackgroundColor,
            closedFlowsTextColor: (_6 = (_5 = options.theme) === null || _5 === void 0 ? void 0 : _5.closedFlowsTextColor) !== null && _6 !== void 0 ? _6 : baseTheme.closedFlowsTextColor,
            closedFlowsSuggestionColor: (_8 = (_7 = options.theme) === null || _7 === void 0 ? void 0 : _7.closedFlowsSuggestionColor) !== null && _8 !== void 0 ? _8 : baseTheme.closedFlowsSuggestionColor,
            primaryTextColor: (_10 = (_9 = options.theme) === null || _9 === void 0 ? void 0 : _9.primaryTextColor) !== null && _10 !== void 0 ? _10 : baseTheme.primaryTextColor,
            secondaryTextColor: (_12 = (_11 = options.theme) === null || _11 === void 0 ? void 0 : _11.secondaryTextColor) !== null && _12 !== void 0 ? _12 : baseTheme.secondaryTextColor,
            foreground: (_14 = (_13 = options.theme) === null || _13 === void 0 ? void 0 : _13.primaryTextColor) !== null && _14 !== void 0 ? _14 : baseTheme.primaryTextColor,
            contentColor: (_16 = (_15 = options.theme) === null || _15 === void 0 ? void 0 : _15.primaryTextColor) !== null && _16 !== void 0 ? _16 : baseTheme.primaryTextColor,
            secondaryBackground: (_18 = (_17 = options.theme) === null || _17 === void 0 ? void 0 : _17.cardBackgroundColor) !== null && _18 !== void 0 ? _18 : baseTheme.cardBackgroundColor,
        },
        showSuggestionsWhenClosed: (_19 = options.showSuggestionsWhenClosed) !== null && _19 !== void 0 ? _19 : true,
        baseUrl,
        projectId: options.projectId,
        publicKey: options.publicKey,
        language: options.language,
        preview: (_20 = options.preview) !== null && _20 !== void 0 ? _20 : false,
        previewConfiguration: options.previewConfiguration,
        additionalData: options.additionalData,
        authToken: options.authToken,
        testWidget: (_21 = options.testWidget) !== null && _21 !== void 0 ? _21 : false,
        engine: (_22 = options.engine) !== null && _22 !== void 0 ? _22 : "project",
        browserSearchReasoningEffort: options.browserSearchReasoningEffort,
    };
}
function resolveTarget(target) {
    if (typeof target === "string") {
        let el = document.getElementById(target);
        if (!el) {
            el = document.createElement("div");
            el.id = target;
            document.body.appendChild(el);
        }
        return el;
    }
    if (target instanceof HTMLElement)
        return target;
    const fallback = document.createElement("div");
    fallback.id = "chatbot-widget";
    document.body.appendChild(fallback);
    return fallback;
}
function mount(options = {}) {
    const merged = mergeOptions(options);
    const target = resolveTarget(merged.target);
    const root = createRoot(target);
    root.render(_jsx(WidgetApp, { options: merged }));
    return { unmount: () => root.unmount() };
}
function readScriptOptions() {
    var _a, _b, _c, _d, _e;
    if (typeof document === "undefined")
        return {};
    const script = (_a = document.currentScript) !== null && _a !== void 0 ? _a : document.querySelector("script[data-chatbot-widget]");
    if (!script)
        return {};
    const rawTheme = script.getAttribute("data-theme");
    const themeName = rawTheme === "dark" ? "dark" : rawTheme === "light" ? "light" : undefined;
    return {
        projectId: (_b = script.getAttribute("data-project-id")) !== null && _b !== void 0 ? _b : undefined,
        publicKey: (_c = script.getAttribute("data-public-key")) !== null && _c !== void 0 ? _c : undefined,
        apiBaseUrl: (_d = script.getAttribute("data-api-base-url")) !== null && _d !== void 0 ? _d : undefined,
        language: (_e = script.getAttribute("data-language")) !== null && _e !== void 0 ? _e : undefined,
        themeName,
    };
}
function autoMount() {
    const markerId = "chatbot-floating-anchor";
    if (document.getElementById(markerId))
        return;
    const scriptOptions = readScriptOptions();
    if (!scriptOptions.projectId || !scriptOptions.publicKey) {
        console.warn("ChatbotWidget: projectId and publicKey are required to auto-mount. Add data-project-id and data-public-key attributes to the loader script or call mount manually.");
        return;
    }
    const el = document.createElement("div");
    el.id = markerId;
    document.body.appendChild(el);
    mount({ target: el, floating: true, showSuggestionsWhenClosed: true, ...scriptOptions });
}
if (typeof window !== "undefined") {
    window.ChatbotWidget = {
        mount,
        autoMount,
        version: "1.0.0",
    };
    if (!window.__CHATBOT_WIDGET_AUTOMOUNTED__) {
        window.__CHATBOT_WIDGET_AUTOMOUNTED__ = true;
        autoMount();
    }
}
export { mount };
